<div class="page-wrapper">
  <section class="about-breadcrumb">
    <div class="about-breadcrumb-overlay">
      <div class="container-fluid">
        <div class="banner-detail-copy">
          <p class="banner-eyebrow">Contact DotBlack</p>
          <h1>Let's discuss what you need to deliver.</h1>
          <p class="banner-lead">
            Tell us about the technology challenge, process, programme or skills requirement you are working through.
            A member of the DotBlack team will review your enquiry.
          </p>

          <div class="banner-contact-grid" aria-label="DotBlack contact details">
            <div class="banner-contact-item">
              <span class="banner-contact-label">Call</span>
              <a href="tel:+27115685421">+27 11 568 5421</a>
            </div>
            <div class="banner-contact-item">
              <span class="banner-contact-label">Email</span>
              <a href="mailto:mufk@dotblack.co.za">mufk@dotblack.co.za</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <main class="contact-page" id="contact-enquiry">
    <div class="contact-shell">
      <section class="contact-intro" aria-labelledby="contact-intro-title">
        <p class="contact-kicker">Pretoria, South Africa</p>
        <h2 id="contact-intro-title">Start with the outcome you need.</h2>
        <p class="contact-intro-copy">
          Complete the form with enough context for us to direct your enquiry to the right person.
        </p>

        <div class="contact-info-block">
          <h3>Office</h3>
          <p>
            Office 0005, Jardown 1<br>
            377 Johannes Ramokhoase Street<br>
            Pretoria Central, 0002
          </p>
        </div>

        <div class="contact-info-block">
          <h3>Operating hours</h3>
          <p>
            Monday to Friday<br>
            08:30 to 16:30
          </p>
        </div>

        <div class="contact-info-block direct-contact">
          <h3>Direct contact</h3>
          <p>
            <a href="tel:+27115685421">+27 11 568 5421</a><br>
            <a href="mailto:mufk@dotblack.co.za">mufk@dotblack.co.za</a>
          </p>
        </div>
      </section>

      <section class="contact-form-panel" aria-labelledby="contact-form-title">
        <div class="form-heading">
          <p class="form-kicker">Send an enquiry</p>
          <h2 id="contact-form-title">Tell us what you are working through.</h2>
        </div>

        <form
          class="contact-form"
          id="contactForm"
          (submit)="submitEnquiry($event)"
        >
          <div class="form-grid">
            <div class="form-field">
              <label for="name">Full name</label>
              <input
                id="name"
                type="text"
                name="name"
                required
                autocomplete="name"
                placeholder="Your full name"
              >
            </div>

            <div class="form-field">
              <label for="email">Work email</label>
              <input
                id="email"
                type="email"
                name="email"
                required
                autocomplete="email"
                placeholder="name@organisation.co.za"
              >
            </div>

            <div class="form-field">
              <label for="phone_number">Telephone number</label>
              <input
                id="phone_number"
                type="tel"
                name="phone_number"
                autocomplete="tel"
                placeholder="+27 ..."
              >
            </div>

            <div class="form-field">
              <label for="organisation">Organisation</label>
              <input
                id="organisation"
                type="text"
                name="organisation"
                autocomplete="organization"
                placeholder="Organisation name"
              >
            </div>
          </div>

          <div class="form-field full-width">
            <label for="interest">What would you like to discuss?</label>
            <select id="interest" name="interest" required>
              <option value="" selected disabled>Select a topic</option>
              <option value="IT consulting">IT consulting</option>
              <option value="Intelligent automation">Intelligent automation</option>
              <option value="Programme or project management">Programme or project management</option>
              <option value="Specialist IT teams">Specialist IT teams</option>
              <option value="MUF-K.Integrated">MUF-K.Integrated</option>
              <option value="Partnership">Partnership</option>
              <option value="Careers">Careers</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div class="form-field full-width">
            <label for="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="7"
              required
              placeholder="Briefly describe your current situation, desired outcome and preferred timing."
            ></textarea>
          </div>

          <div class="privacy-consent">
            <input id="privacy-consent" type="checkbox" name="privacy_consent" value="agreed" required>
            <label for="privacy-consent">
              I agree that DotBlack may use this information to respond to my enquiry, as explained in the
              <a routerLink="/privacy-notice">Privacy Notice</a>.
            </label>
          </div>

          <div class="form-actions">
            <button class="contact-submit-btn" type="submit" [disabled]="submissionState === 'submitting'">
              <span *ngIf="submissionState !== 'submitting'">Send your enquiry <span aria-hidden="true">↗</span></span>
              <span *ngIf="submissionState === 'submitting'">Sending enquiry...</span>
            </button>
          </div>

          <div
            *ngIf="submissionState === 'success'"
            class="form-status form-status-success"
            role="status"
            aria-live="polite"
          >
            <strong>Thank you. Your enquiry has been submitted successfully.</strong>
            <span>A member of the DotBlack team will review it and respond as soon as possible.</span>
          </div>

          <div
            *ngIf="submissionState === 'error'"
            class="form-status form-status-error"
            role="alert"
          >
            <strong>We could not submit your enquiry.</strong>
            <span>{{ submissionError }} If the problem continues, email <a href="mailto:mufk@dotblack.co.za">mufk@dotblack.co.za</a>.</span>
          </div>

          <p class="form-privacy-note">
            Your information is used only to review and respond to this enquiry, subject to DotBlack's privacy practices.
          </p>

          <input type="text" name="_honey" class="honeypot" tabindex="-1" autocomplete="off" aria-hidden="true">
        </form>
      </section>
    </div>
  </main>
</div>
